import { createRouter, createWebHistory } from "vue-router";
import PlacesList from "../views/PlacesList.vue";
import PlaceDetails from "../views/PlaceDetails.vue";
import NotFoundComponent from "../views/NotFoundComponent";

const routes = [
  {
    path: "/",
    name: "Places",
    component: PlacesList,
  },
  {
    path: "/place/:id",
    name: "PlaceDetails",
    component: PlaceDetails,
    props: true,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/:catchAll(.*)",
    component: NotFoundComponent,
    name: "NotFound",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
